angular.module('cian.metroBrowser').directive('metroShadow', ['$sce', function($sce) {
  return {
    scope: {},
    template: require('../../templates/metro-svg-browser.shadow.html'),
    templateNamespace: 'svg',
    restrict: 'A',
    link($scope, $element, attrs) {

    },
    bindToController: {
      metroData: '<',
      metroState: '=',
    },
    controller: [function() {
      this.trust = (...args) => $sce.trustAsHtml.apply(this, args);

      this.isApplyShadowClass = (...ids) => {
        return ids.every((id, index, arr) => {
          let isHover;

          if (index === 0) {
            isHover = this.metroState.lines[id].isHover;
          } else if (index === 1) {
            isHover = this.metroState.segments[id].isHover;
          } else {
            isHover = this.metroState.stations[id].isHover;
          }

          return (arr.length - 1) === index ? isHover : !isHover;
        });
      };

      this.getBlurFilter = (...params) => this.isApplyShadowClass.apply(this, params) === true ? 'url(#blur-filter)' : '';

      this.isStationActive = (stationId) => this.metroState.stations[stationId].isActive;
      this.getStationRadius = (stationId) => this.isStationActive(stationId) ? 6.75 : 6.5;
    }],
    controllerAs: 'shadowCtrl'
  };
}]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-svg-browser.shadow.dir.js